import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, Heart } from 'lucide-react';
export function EmotionalStory() {
  const checklist = ['Te despiertas cansada antes de que empiece el día', 'No tienes a quién llamar cuando todo explota', 'Tu mente no para — mil cosas al mismo tiempo', 'Amas a tus hijos más que a nada — pero a veces no encuentras paz ni para ti', 'Has intentado cosas pero nada te ha hecho sentir realmente entendida', 'En el fondo sientes que si tuvieras más calma — podrías lograr todo lo que sueñas'];
  return <section className="py-24 bg-warm-deep relative overflow-hidden" data-id="element-47">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-brown/10 to-transparent" data-id="element-48" />

      <div className="max-w-4xl mx-auto px-6 md:px-8" data-id="element-49">
        {/* SECCIÓN 2 | VALIDACIÓN & ESPEJO */}
        <FadeIn className="text-center mb-16" data-id="element-50">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-10" data-id="element-51">
            ¿Te suena conocido algo de esto?
          </h2>

          <div className="bg-cream/80 backdrop-blur-sm rounded-3xl p-6 md:p-10 shadow-sm border border-warm-deeper/50 text-left space-y-4" data-id="element-52">
            {checklist.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-53">
                <div className="text-gold mt-1 flex-shrink-0" data-id="element-54">
                  <CheckCircle2 size={24} data-id="element-55" />
                </div>
                <p className="text-lg md:text-xl text-brown-light leading-relaxed" data-id="element-56">
                  {item}
                </p>
              </div>)}
          </div>

          <p className="text-xl font-heading italic text-brown mt-8" data-id="element-57">
            Si marcaste aunque sea dos de estas — estás exactamente donde
            necesitas estar.
          </p>
        </FadeIn>

        {/* SECCIÓN 3 | TU HISTORIA */}
        <div className="mt-24 space-y-8 text-lg md:text-xl text-brown-light leading-relaxed" data-id="element-58">
          <FadeIn delay={0.1} data-id="element-59">
            <h3 className="text-3xl font-bold text-brown mb-6 text-center" data-id="element-60">
              Yo también estuve ahí.
            </h3>

            <div className="flex justify-center my-8" data-id="element-61">
              <img src="https://cdn.magicpatterns.com/uploads/2Ew6oVFk7mrpM3z9z8jMBs/con_rafi_1_web.webp" alt="Pierina con Rafaella" className="w-44 h-44 md:w-56 md:h-56 rounded-full shadow-lg border-4 border-warm-deeper/30 object-cover bg-[#5A4A41]" style={{
              objectPosition: 'center 25%'
            }} data-id="element-62" />
            </div>

            <p data-id="element-63">Me llamo Pierina.</p>
            <p data-id="element-64">
              Soy mamá de Rafaella. Mamá soltera. Inmigrante. Sin familia cerca.
              Sin red de apoyo y con un TDAH que no fue atendido en mi infancia.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-65">
            <p data-id="element-66">
              Crecí escuchando: "Exageras." "Eres muy sensible."... hasta que me
              convertí en mamá y hubo un momento en que sentí que no podía más.
            </p>
            <p data-id="element-67">
              No era solo cansancio. Era ese peso que no se va ni cuando
              duermes. Esa sensación de estar fallando — aunque te estés
              partiendo en dos por tus hijos.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-68">
            <div className="my-12 p-8 bg-cream rounded-2xl shadow-sm border border-warm-deeper/50 relative" data-id="element-69">
              <div className="absolute -top-4 -left-4 text-gold/20" data-id="element-70">
                <Heart size={64} fill="currentColor" data-id="element-71" />
              </div>
              <p className="text-xl md:text-2xl font-heading text-brown text-center relative z-10 italic" data-id="element-72">
                Pero Rafaella me necesitaba. Y eso fue suficiente para no
                rendirme.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-73">
            <p data-id="element-74">
              De la mano de Dios — un día a la vez — aprendí a salir del caos.
            </p>
            <p data-id="element-75">Si marcaste aunque sea dos estás en el lugar correcto.</p>
            <p className="font-bold text-brown mt-8" data-id="element-76">
              Y cuando vi que funcionaba — decidí que ninguna mamá debería tener
              que descubrirlo sola.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}